import { DisplayFromFHIRCodeableConcept } from "./CodeableConceptEntry";
import { CodingDisplay } from "./CodingEntry";
import { displayStringFromFHIRPeriod, getDateTimeDisplay } from "./PeriodEntry";
import { displayStringFromFHIRQuantity } from "./QuantityEntry";
import { DisplayFromFHIRReference } from "./ReferenceEntry";
import { DisplayFromFHIRUri } from "./UriEntry";

const DisplayFromFHIRDataRequirement = ({ dataRequirement, containedResourceDictionary = {} }) => {
    if (dataRequirement) {
        if (Array.isArray(dataRequirement) || typeof dataRequirement != "object") {
            return <>[ERROR: DataRequirement data not interpretable.]</>;
        } else {
            return <div style={{ marginLeft: "24px", wordBreak: "break-all" }}>
                {dataRequirement.type && <><b>Type:</b> {dataRequirement.type}<br /></>}
                {dataRequirement.profile?.length > 0 &&
                    dataRequirement.profile.map((profile, profileIndex) => {
                        return <span key={profileIndex}>
                            <b>Profile:</b> <DisplayFromFHIRUri uri={profile} /><br />
                        </span>
                    })
                }
                {dataRequirement.subjectCodeableConcept &&
                    <span>
                        <b>Subject: </b><DisplayFromFHIRCodeableConcept codeableConcept={dataRequirement.subjectCodeableConcept} />
                    </span>
                }
                {dataRequirement.subjectReference &&
                    <span>
                        <b>Subject: </b><DisplayFromFHIRReference reference={dataRequirement.subjectReference}
                            containedResourceJson={dataRequirement.subjectReference.reference && containedResourceDictionary[dataRequirement.subjectReference.reference]} />
                    </span>
                }
                {dataRequirement.mustSupport?.length > 0 &&
                    dataRequirement.mustSupport.map((must, mustIndex) => {
                        return <span key={mustIndex}><b>Must Support:</b> {must}<br /></span>
                    })
                }
                {dataRequirement.codeFilter?.length > 0 &&
                    dataRequirement.codeFilter.map((codeFilter, codeFilterIndex) => {
                        return <span key={codeFilterIndex}>
                            <b>Code Filter:</b>
                            <div style={{ marginLeft: "24px" }}>
                                {codeFilter.path && <><b>Path:</b> {codeFilter.path}<br /></>}
                                {codeFilter.searchParam && <><b>Search Parameter:</b> {codeFilter.searchParam}<br /></>}
                                {codeFilter.valueSet && <><b>Value Set:</b> <DisplayFromFHIRUri uri={codeFilter.valueSet} /><br /></>}
                                {codeFilter.code?.length > 0 &&
                                    codeFilter.code.map((code => { return <CodingDisplay coding={code} /> })).join('; ')
                                }
                            </div>
                        </span>
                    })
                }
                {dataRequirement.dateFilter?.length > 0 &&
                    dataRequirement.dateFilter.map((dateFilter, dateFilterIndex) => {
                        return <span key={dateFilterIndex}>
                            <b>Date Filter:</b>
                            <div style={{ marginLeft: "24px" }}>
                                {dateFilter.path && <><b>Path:</b> {dateFilter.path}<br /></>}
                                {dateFilter.searchParam && <><b>Search Parameter:</b> {dateFilter.searchParam}<br /></>}
                                {dateFilter.valueDateTime && <>
                                    <b>Value:</b> {getDateTimeDisplay(dateFilter.valueDateTime)}<br />
                                </>}
                                {dateFilter.valuePeriod && <>
                                    <b>Value:</b> {displayStringFromFHIRPeriod(dateFilter.valuePeriod)}<br />
                                </>}
                                {dateFilter.valueDuration && <>
                                    <b>Value:</b> {displayStringFromFHIRQuantity(dateFilter.valueDuration)}<br />
                                </>}
                            </div>
                        </span>
                    })
                }
                {dataRequirement.valueFilter?.length > 0 &&
                    dataRequirement.valueFilter.map((valueFilter, valueFilterIndex) => {
                        return <span key={valueFilterIndex}>
                            <b>Value Filter:</b>
                            <div style={{ marginLeft: "24px" }}>
                                {valueFilter.path && <><b>Path:</b> {valueFilter.path}<br /></>}
                                {valueFilter.searchParam && <><b>Search Parameter:</b> {valueFilter.searchParam}<br /></>}
                                {valueFilter.comparator && <><b>Comparator:</b> {valueFilter.comparator}<br /></>}
                                {valueFilter.valueDateTime && <>
                                    <b>Value:</b> {getDateTimeDisplay(valueFilter.valueDateTime)}<br />
                                </>}
                                {valueFilter.valuePeriod && <>
                                    <b>Value:</b> {displayStringFromFHIRPeriod(valueFilter.valuePeriod)}<br />
                                </>}
                                {valueFilter.valueDuration && <>
                                    <b>Value:</b> {displayStringFromFHIRQuantity(valueFilter.valueDuration)}<br />
                                </>}
                            </div>
                        </span>
                    })
                }

                {dataRequirement.limit && <><b>Limit:</b> {dataRequirement.limit}<br /></>}
                {dataRequirement.sort?.length > 0 &&
                    dataRequirement.sort.map((sort, sortIndex) => {
                        return <span key={sortIndex}><b>Sort by: </b> {sort.path}, {sort.direction}<br /></span>
                    })
                }
            </div >
        }
    } else {
        return <></>
    }
}

export default DisplayFromFHIRDataRequirement;